import React from 'react';
import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';

const Demo = () => {
  return (
    <>
      <Helmet>
        <title>Demo - HawkClient</title>
        <meta
          name="description"
          content="View the demo for HawkClient, a developer-friendly offline-only API client."
        />
      </Helmet>

      <Box
        sx={{
          p: 8,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        {/* First Video Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // responsive: stack on small screens
            alignItems: "flex-start",
            gap: 3,
          }}
        >
          {/* Video */}
          <Box
            component="iframe"
            src="https://www.youtube.com/embed/fu8xDSnUoIU"
            sx={{
              flex: "0 0 60%",
              width: "100%",
              maxWidth: "800px",
              height: "450px",
              border: "none",
              borderRadius: "12px",
              boxShadow: 3,
            }}
            title="HawkClient Demo Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />

          {/* Text */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" gutterBottom>
              Demo Video
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Watch the demo of HawkClient to understand how it works and how it
              can simplify your API testing workflow.
            </Typography>
          </Box>
        </Box>

        {/* Third Video Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "flex-start",
            gap: 3,
          }}
        >
          {/* Video */}
          <Box
            component="iframe"
            src="https://www.youtube.com/embed/UJDntPKk2Hk"
            sx={{
              flex: "0 0 60%",
              width: "100%",
              maxWidth: "800px",
              height: "450px",
              border: "none",
              borderRadius: "12px",
              boxShadow: 3,
            }}
            title="HawkClient API Flows Demo Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />

          {/* Text */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" gutterBottom>
              API Flow with For Loop
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Learn how to use For Loops in HawkClient to automate API workflows and iterate over dynamic data like user lists.
            </Typography>
          </Box>
        </Box>

        {/* Second Video Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "flex-start",
            gap: 3,
          }}
        >
          {/* Video */}
          <Box
            component="iframe"
            src="https://www.youtube.com/embed/9IqkVy_3iXc"
            sx={{
              flex: "0 0 60%",
              width: "100%",
              maxWidth: "800px",
              height: "450px",
              border: "none",
              borderRadius: "12px",
              boxShadow: 3,
            }}
            title="HawkClient API Flows Demo Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />

          {/* Text */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" gutterBottom>
              API Flows Demo
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Learn how API flows work in HawkClient to create powerful,
              reusable workflows for your APIs with ease.
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Demo;
